import { Route as SalesPerItemRoute } from "@/routes/(inventory)/branch/_layout/reports/sales-per-item/index";
import { useQuery } from "@tanstack/react-query";
import { getSalesPerItem } from "../-data/api";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useSalesPerItemData = () => {
  const searchParams = SalesPerItemRoute.useSearch();
  
  return useQuery<ReportQueryResult>({
    queryKey: ["sales-per-item", searchParams],
    queryFn: async () => {
      const response = await getSalesPerItem(searchParams.page || 1, searchParams.pageSize || 10);
      return {
        items: response.salesPerItemItems,
        totalCount: response.totalCount,
        page: searchParams.page || 1,
        pageSize: searchParams.pageSize || 10,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};